<template>
  <div  class="table-responsive card-body"
        ref="scrollableContainer"
        v-loading="loading">
    <el-table
      class="table-responsive table-flush"
      :header-row-class-name="thead-light"
      :data="preferredproducts"
      style="width: 100%;"
    >
      <el-table-column
        v-if="filters.tableColumn.includes('Produto') || filters.tableColumn.includes('Todas')"
        label="Produto"
        v-slot="{ row }"
        min-width="180px"
        sortable
        prop="name"
      >
        {{ row.name }} - {{ unityVolumeTranslator(row.unity_type) }}
      </el-table-column>
      <el-table-column
        v-if="filters.tableColumn.includes('Custo') || filters.tableColumn.includes('Todas')"
        v-slot="{ row }"
        label="Custo"
        min-width="160px"
        prop="product_last_price_average"
      >
        {{ row.product_last_price_average === 0 ? 'N/A' : row.product_last_price_average.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
      </el-table-column>
      <el-table-column
        v-if="filters.tableColumn.includes('Vol. Meta Fornec.') || filters.tableColumn.includes('Todas')"
        v-slot="{ row }"
        label="Vol. Meta Fornec."
        min-width="180px"
      >
        <div style="margin: 8px 32px 0 0;">
          <base-input
            wrapper-class="mb-0"
            input-classes="form-control-sm"
            @input="updateSupplierPurchaseGoalVolume(row.id, $event)"
            :value="supplierGoalVolume(row.id)"
            :disabled="!filters.anosafra.is_open"
            mask="integer"
            @blur="saveSupplierPurchaseGoal(row.id)"
          />
        </div>
      </el-table-column>
      <el-table-column
        v-if="filters.tableColumn.includes('R$ Meta Fornec.') || filters.tableColumn.includes('Todas')"
        v-slot="{ row }"
        label="R$ Meta Fornec."
        min-width="180px"
        prop="unitary_price"
        sortable
      >
        {{ ((row.unitary_price || 0) * supplierGoalVolume(row.id) || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl'}) }}
      </el-table-column>
      <el-table-column
        v-if="filters.tableColumn.includes('Saldo em Estoque') || filters.tableColumn.includes('Todas')"
        v-slot="{ row }"
        label="Saldo em Estoque"
        min-width="180px"
        prop=""
        sortable
      >
        {{ ((summarizedStockVolume && summarizedStockVolume[row.id]) || 0 ).toLocaleString('pt-BR') }}
      </el-table-column>
      <el-table-column
        v-if="filters.tableColumn.includes('R$ Estoque') || filters.tableColumn.includes('Todas')"
        v-slot="{ row }"
        label="R$ Estoque"
        min-width="160px"
        prop="unitary_price"
        sortable
      >
        {{ (((row.unitary_price || 0) *  (((summarizedStockVolume && summarizedStockVolume[row.id]) || 0 ))) || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl'}) }}
      </el-table-column>
      <el-table-column
        v-if="filters.tableColumn.includes('Volume Meta Dist.SGV') || filters.tableColumn.includes('Todas')"
        v-slot="{ row }"
        label="Volume Meta Dist.SGV"
        min-width="180px"
        prop="total_volume"
      >
        {{ row.total_volume.toLocaleString('pt-BR') || 0  }}
      </el-table-column>
      <el-table-column
        v-if="filters.tableColumn.includes('R$ Meta Dist.SGV') || filters.tableColumn.includes('Todas')"
        v-slot="{ row }"
        label="R$ Meta Dist.SGV"
        min-width="180px"
        prop="unitary_price"
      >
        {{ ((row.unitary_price || 0) * row.total_volume).toLocaleString('pt-BR', {style: 'currency', currency: 'brl'}) }}
      </el-table-column>
      <el-table-column
        v-if="filters.tableColumn.includes('Saldo Meta Forne.') || filters.tableColumn.includes('Todas')"
        v-slot="{ row }"
        label="Saldo Meta Forne."
        min-width="180px"
        sortable
      >
        {{ ((supplierGoalVolume(row.id) - (((summarizedStockVolume && summarizedStockVolume[row.id]) || 0 ))).toLocaleString('pt-BR')  || 0) }}
      </el-table-column>
      <el-table-column
        v-if="filters.tableColumn.includes('R$ Compra') || filters.tableColumn.includes('Todas')"
        v-slot="{ row }"
        label="R$ Compra"
        min-width="180px"
        sortable
      >
        {{ (((supplierGoalVolume(row.id) - (((summarizedStockVolume && summarizedStockVolume[row.id]) || 0 ))) * row.unitary_price) || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl'}) }}
      </el-table-column>
      <el-table-column
        v-if="filters.tableColumn.includes('Meta Fornecedor x Vol Distribuído') || filters.tableColumn.includes('Todas')"
        v-slot="{ row }"
        label="Meta Fornecedor x Vol Distribuído"
        min-width="160px"
        prop="total_volume"
        sortable
      >
        {{ ((supplierGoalVolume(row.id) - row.total_volume) || 0).toLocaleString('pt-BR') }}
      </el-table-column>
      <el-table-column
        v-slot="{ row }"
        label=""
        min-width="80px"
      >
      </el-table-column>
      <el-table-column
        v-if="filters.tableColumn.length === 0"
        label="Nenhuma coluna selecionada"
        min-width="300px"
      >
        <template #default>
          Selecione pelo menos uma coluna para visualizar os dados
        </template>
      </el-table-column>
    </el-table>
    <br>
    <div class="loading-spinner-container">
      <div v-show="loadingMore" class="loading-spinner"></div>
    </div>
    </div>
</template>

<script>
import { Table, TableColumn, Tooltip } from "element-ui";

export default {
  name: "SupplierPurchaseGoalTable",
  components: {
    [Table.name]: Table,
    [Tooltip.name]: Tooltip,
    [TableColumn.name]: TableColumn,
  },

  props: {
    active: {
      type: Boolean,
      default: false,
      description: "Indicates if the table is active"
    },
    brandId: {
      type: Number,
      description: "Brand ID"
    },
    filters: {
      type: Object,
      default: () => {},
      description: "Filters"
    },
  },
  mounted() {
    const scrollableContainer = this.$refs.scrollableContainer;
    if (scrollableContainer) {
      scrollableContainer.addEventListener('scroll', this.debouncedOnScroll);
    }
    if (this.active) {
      this.populateTableData();
    }
  },
  beforeDestroy() {
    const scrollableContainer = this.$refs.scrollableContainer;
    if (scrollableContainer) {
      scrollableContainer.removeEventListener('scroll', this.debouncedOnScroll);
    }
  },
  methods: {
    async getPreferredproducts(page = 1) {
      let q        = { brand_id: this.brandId, status: 'active' }

      if (this.filters.group_id) q.grupo_id      = this.filters.group_id
      if (this.filters.preferredproduct_id) q.id = this.filters.preferredproduct_id
      q.order = 'name';

      try {
        const response = await this.$http.secured.get('/api/v2/preferredproducts', {
          params: {
            include_last_prices: true,
            page: page,
            per_page: 5,
            enterprise_id: this.$currentUser().enterprise_id,
            anosafra_id: this.filters.anosafra_id,
            q: q,
          },
        });

        if (page > 1) {
          this.preferredproducts = [...this.preferredproducts, ...response.data.data];
        } else {
          this.preferredproducts = response.data.data;
        }

        this.preferredproducts_paginated_data = response.data;
      } catch (error) {
        console.error("[SupplierPurchaseGoalTable] getPreferredproducts", error);
      }
    },
    async getProducts() {
      try {
        const response = await this.$http.secured.get('/api/v1/products');
        this.products = response.data;
      } catch (error) {
        console.error("[SupplierPurchaseGoalTable][getProducts]", error);
      }
    },
    async getsummarizedStockVolume(preferredproduct_ids) {
      let  serviceParams  = { q: { codi_emp: this.filters.codi_emp, preferredproduct_ids: preferredproduct_ids} };

      try {
        const response = await this.$http.secured.get('/api/v1/report/summarized_stock_volume', {
          params: { service_params: serviceParams }
        })

        this.summarizedStockVolume = response.data
      } catch (error) {
        console.error("[SupplierPurchaseGoalTable] getsummarizedStockVolume", error)
      }
    },
    async getSupplierPurchaseGoals(preferredproduct_ids) {
      let q = { preferredproduct_id: preferredproduct_ids, anosafra_id: this.filters.anosafra_id }

      try {
        const response = await this.$http.secured.get('/api/v2/supplier_purchase_goals', {
          params: {
            q: q
          }
        })

        this.supplierPurchaseGoals = response.data.data
      } catch (error) {
        console.error("[SupplierPurchaseGoalTable] getSupplierPurchaseGoals", error)
      }
    },
    updateSupplierPurchaseGoalVolume(preferredproduct_id, volume) {
      const objectIndex = this.supplierPurchaseGoals.findIndex((el) => el.preferredproduct_id == preferredproduct_id)

      if (objectIndex != -1) {
        this.$set(this.supplierPurchaseGoals, objectIndex, { ...this.supplierPurchaseGoals[objectIndex], volume: volume})
        return
      }

      this.supplierPurchaseGoals.push({preferredproduct_id: preferredproduct_id, volume: volume, anosafra_id: this.filters.anosafra_id})
    },
    supplierGoalVolume(preferredproduct_id) {
      const objectIndex = this.supplierPurchaseGoals.findIndex((el) => el.preferredproduct_id == preferredproduct_id)

      return objectIndex != -1 ? parseFloat(this.supplierPurchaseGoals[objectIndex].volume) : 0
    },
    async saveSupplierPurchaseGoal(preferredproduct_id) {
      if (!this.filters.anosafra.is_open) {
        this.$toasted.global.defaultError({ msg: 'Não é possível cadastrar volume de meta para Anos Safras fechados' })
        return
      }

      var objectIndex = this.supplierPurchaseGoals.findIndex((el) => el.preferredproduct_id == preferredproduct_id)

      if (objectIndex  == -1) {
        this.updateSupplierPurchaseGoalVolume(preferredproduct_id, 0)
        objectIndex = this.supplierPurchaseGoals.findIndex((el) => el.preferredproduct_id == preferredproduct_id)
      }

      const supplierPurchaseGoal = this.supplierPurchaseGoals[objectIndex]

      if (supplierPurchaseGoal.volume === this.previousValue) {
        return;
      }
      this.previousValue = supplierPurchaseGoal.volume;

      this.loadingSave = true

      try {
        if (supplierPurchaseGoal.id) {
          await this.$http.secured.put(`/api/v2/supplier_purchase_goals/${supplierPurchaseGoal.id}`, {
           supplier_purchase_goal: supplierPurchaseGoal,
          })
          this.$toasted.global.defaultSuccess({ msg: 'Volume de meta cadastrado com sucesso!'})
          return
        }
        const response = await this.$http.secured.post(`/api/v2/supplier_purchase_goals`, { supplier_purchase_goal: supplierPurchaseGoal })
        const createdSupplierPurchaseGoal = response.data
        this.$set(this.supplierPurchaseGoals, objectIndex, { ...supplierPurchaseGoal, id: createdSupplierPurchaseGoal.id})
        this.$toasted.global.defaultSuccess({ msg: 'Volume de meta cadastrado com sucesso!'})
      } catch (error) {
        console.error("[SupplierPurchaseGoalTable] saveSupplierPurchaseGoal", error)
      } finally {
        this.loadingSave = false
      }
    },
    async populateTableData(page) {
      await this.getPreferredproducts(page)
      await this.getsummarizedStockVolume(this.preferredproducts.map((el) => el.id))
      await this.getSupplierPurchaseGoals(this.preferredproducts.map((el) => el.id))
    },
    handleScroll(event) {
      if (this.loadingMore) return;

      const scrollableContainer = event.target;
      if (scrollableContainer.scrollHeight - scrollableContainer.scrollTop <= scrollableContainer.clientHeight + 200) {
        this.loadMore();
      }
    },
    async loadMore() {
      const scrollableContainer = this.$refs.scrollableContainer;
      const currentScrollPosition = scrollableContainer ? scrollableContainer.scrollTop : 0;

      this.page += 1;
      this.loadingMore = true;
      await this.populateTableData(this.page);
      this.loadingMore = false;

      this.$nextTick(() => {
        if (scrollableContainer) {
          scrollableContainer.scrollTop = currentScrollPosition;
        }
      });
    },
    debouncedOnScroll(event) {
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout);

      this.debounceTimeout = setTimeout(() => {
        this.handleScroll(event);
      }, 200);
    },
    unityVolumeTranslator(unity) {
      if (!unity) return "Não Definido";
      if (["K", "GL", "SC", "FR", "LT", "KG", "L", "BD"].includes(unity.toUpperCase())) return "KG/LT";
      if (unity.toUpperCase() == "D") return "DOSE";
      if (unity.toUpperCase() == "M") return "MX";
      if (unity.toUpperCase() == "U") return "UNIDADE";

      return "Não Definido";
    },
  },
  data() {
    return {
      preferredproducts_paginated_data: [],
      preferredproducts: [],
      loading: false,
      summarizedStockVolume: {},
      supplierPurchaseGoals: [],
      loadingSave: false,
      loadingMore: false,
      debounceTimeout: null,
      products: [],
      page: 1,
      tableColumn: ['Produto', 'Custo', 'Vol. Meta Fornec.', 'R$ Meta Fornec.', 'Saldo em Estoque', 'R$ Estoque',
        'Volume Meta Dist.SGV', 'R$ Meta Dist.SGV', 'Saldo Meta Forne.', 'R$ Compra', 'Meta Fornecedor x Vol Distribuído', 'Todas'
      ]
    }
  },
  computed: {
    isCurrentAnosafraDifferent() {
      const currentAnosafra = this.$store.state.currentAnosafra;
      return this.filters.anosafra_id !== currentAnosafra.id;
    },
    orderedColumns() {
      if (!this.filters.tableColumn) return [];

      return this.tableColumn.filter(col =>
        this.filters.tableColumn.includes(col) ||
        (col === 'Todas' && this.filters.tableColumn.includes('Todas'))
      );
    }
  },
  watch: {
    active: async function (val) {
      if (val) {
        this.loading = true
        await this.populateTableData()
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.loading-indicator {
  text-align: center;
  margin: 20px 0;
}
.card-body {
  height: 300px;
  overflow-y: auto;
}
.loading-spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  height: 40px;
}

.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
